import { render } from "./NestedCategory.vue?vue&type=template&id=2cbf0fdd"
import script from "./NestedCategory.vue?vue&type=script&lang=js"
export * from "./NestedCategory.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__